export default {
  availableRoles(state, payload) {
    state.availableRoles = payload.availableRoles;
  },
};
